module.exports = __webpack_public_path__ + "static/media/delete_icon_list.48cd9aa0.svg";